import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Sort3"
});
const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.92932 5.25905C2.2517 5.25905 2.04681 4.85539 2.47072 4.35859L5.23173 1.12279C5.65608 0.62548 6.34451 0.625991 6.76842 1.12279L9.52943 4.35859C9.95377 4.8559 9.74702 5.25905 9.07083 5.25905H2.92932Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.92932 6.74097C2.2517 6.74097 2.04681 7.14463 2.47072 7.64143L5.23173 10.8772C5.65608 11.3745 6.34451 11.374 6.76842 10.8772L9.52943 7.64143C9.95377 7.14412 9.74702 6.74097 9.07083 6.74097H2.92932Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var sort3 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { sort3 as default };
